import Button from 'react-bootstrap/Button';
import PropTypes from "prop-types";
import React from "react";
import InputPlusAndMinus from "../../shared-components/InputPlusAndMinus";
import { Container, Col, Row } from 'react-bootstrap';

class OrderItemPacks extends React.Component {
  state = {
    packageTotal: 0,
    packagePrice: 0,
    packageQuantity: 0
  };

  componentDidMount() {
    const { price, packageQuantity } = this.props.packageItem;
    this.setState((prevState, props) => {
      // if (prevState.packageQuantity !== props.packageQuantity) {
      return {
        packagePrice: parseFloat(price, 10),
        packageQuantity: Number(packageQuantity)
      };
      // }
    });
  }

  getTotal = () => {
    return (
      parseFloat(this.state.packagePrice) * Number(this.state.packageQuantity)
    );
  };

  deletePackage = packageItem => {
    if (packageItem.canOrderMultiple) {
      packageItem.packageQuantity = 0;
      this.props.updateBasket(packageItem);
      this.props.removePackageFromBasket(packageItem);
    } else {
      this.props.removePackageFromBasket(packageItem);
    }
  };

  updatePackageQuantity = (amount, packageItem) => {
    const packageQuantity = amount;
    this.setState({ packageQuantity });
    packageItem.packageQuantity = packageQuantity;
    if (packageQuantity === 0) {
      this.props.updateBasket(packageItem);
      this.props.removePackageFromBasket(packageItem);
    } else {
      this.props.updateBasket(packageItem);
    }
  };

  render() {
    const { packageItem } = this.props;
    const { packageQuantity } = this.state;

    return (
      <Container fluid="true">
        <Row className="order-drawer__selection">
          <Col xs={11} className="order-drawer__selection-info">
            <Row className="order-drawer__selection-details">
              <Col xs={10}>
                <strong>{packageItem.Name}</strong>
              </Col>
            </Row>

            <Row className="order-drawer__selection-details">
              <Col xs={10} className="order-drawer__add-container">
                <Row style={{alignItems: 'center'}}>
                  <Col xs={3} sm={7}>
                    <strong>Added </strong>
                  </Col>
                  <Col xs={6} sm={4} className="order-drawer__plus-minus-container">
                    <InputPlusAndMinus
                      max={100}
                      min={0}
                      updateFunction={value => {
                        this.updatePackageQuantity(value, packageItem);
                      }}
                      defaultValue={packageItem.packageQuantity}
                    />
                  </Col>
                </Row>
              </Col>
              <Col xs={2} sm={1}>
                £
                {(packageQuantity * parseFloat(packageItem.price)).toFixed(2)}
              </Col>
            </Row>

            <hr />

            <Row>
              <Col xs={10} />
              <Col xs={2}>
                <strong>
                  £
                  {parseFloat(this.getTotal()).toFixed(2)}
                </strong>
              </Col>
            </Row>
          </Col>

          <Col xs={1} className="order-drawer__delete">
            <Button
              className="order-drawer__delete-btn"
              aria-label="Delete"
              onClick={e => this.deletePackage(packageItem)}
            >
              <i className="far fa-times-circle"></i>
            </Button>
          </Col>
        </Row>
      </Container>
    );
  }
}

OrderItemPacks.propTypes = {
  packageItem: PropTypes.object,
  removePackageFromBasket: PropTypes.func,
  updateBasket: PropTypes.func
};

export default OrderItemPacks;
